import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-load-modal',
    templateUrl: './load-modal.component.html',
    standalone: false
})
export class LoadModalComponent {

  @Input() showModal: boolean;
  @Input() message: string;

  constructor(
  ) { }

}